document.addEventListener("DOMContentLoaded", () => {

  const container = document.getElementById("animated-suns");
  if (!container) return;

  const sunSVG = `
  <svg viewBox="0 0 120 120" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" stroke="#E7C35A" stroke-width="2.2" stroke-linecap="round">
      <circle cx="60" cy="60" r="18"/>
      ${Array.from({ length: 16 }, (_, i) => {
        const a = (Math.PI * 2 / 16) * i;
        const x1 = 60 + 26 * Math.cos(a);
        const y1 = 60 + 26 * Math.sin(a);
        const x2 = 60 + 42 * Math.cos(a);
        const y2 = 60 + 42 * Math.sin(a);
        return `<line x1="${x1}" y1="${y1}" x2="${x2}" y2="${y2}"/>`;
      }).join("")}
    </g>
  </svg>
  `;

  const animations = ["sunFloat1", "sunFloat2", "sunFloat3"];

  const numberOfSuns = window.innerWidth < 750 ? 15 : 40;

  for (let i = 0; i < numberOfSuns; i++) {

    const sun = document.createElement("div");
    sun.className = "sun";

    const size = 20 + Math.random() * 80;

    sun.style.width = `${size}px`;
    sun.style.height = `${size}px`;

    // Position sur tout l'écran
    sun.style.left = `${5 + Math.random() * 90}%`;
sun.style.top = `${5 + Math.random() * 90}%`;

    sun.style.opacity = 0.08 + Math.random() * 0.15;

    const anim = animations[Math.floor(Math.random() * animations.length)];

    sun.style.animation = `
      ${anim} ${18 + Math.random() * 12}s ease-in-out infinite,
      twinkle ${5 + Math.random() * 4}s ease-in-out infinite
    `;

    sun.style.animationDelay = `-${Math.random() * 20}s`;

    sun.innerHTML = sunSVG;

    container.appendChild(sun);
  }

});